(function () {
    "use strict";

    // @ngInject
    function AddWorkflowControllerCtor($scope, $injector, $modalInstance, ModalService, CompaniesManager, AnalyticsService, AppStates, $state,
                                       WorkflowManager, WorkflowService, PopupMessageService, moment, workspace) {
        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'AddWorkflowController';

        this.modalInstance = $modalInstance;
        this.ModalService = ModalService;
        this.AppStates = AppStates;
        this.$state = $state;
        this.CompaniesManager = CompaniesManager;
        this.AnalyticsService = AnalyticsService;
        this.company = CompaniesManager.getCurrCompany();
        this.WorkflowManager = WorkflowManager;
        this.WorkflowService = WorkflowService;
        this.PopupMessageService = PopupMessageService;
        this.moment = moment;
        this.workspace = workspace;

        this.showSavingIndicator = false;
        this.loadWorkflowsIndicator = true;
        this.showOverDuoAlert = false;


        this.workflows = [];
        this.WorkflowManager.getWorkflowsForCompany(this.company)
            .then(function success(resp) {
                this.loadWorkflowsIndicator = false;
                this.workflows = resp.data.workflows;
            }.bind(this))
            .catch(function fail(resp) {
            }.bind(this))
            .finally(function finallyHandler() {
            }.bind(this));


    }

    Controllers.AddWorkflowController = Class(Controllers.BaseController, {
        constructor: AddWorkflowControllerCtor,

        cancelModal: function cancelModal() {
            this.modalInstance.dismiss();
        },

        goToWorkflow: function goToWorkflow() {
            this.modalInstance.dismiss();
            this.goToState(this.AppStates.root_core_navigation_workflows);
        },

        setWorkflowInstanceAlert: function setWorkflowInstanceAlert(workflow) {
            if (!this.workspace.event.event_date) {
                this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                    'WORKFLOW.ALERTS._ADD_WORKFLOW_DATE_TBD_',
                    function clickedYeah() {
                        this.setWorkflowInstance(workflow);
                    }.bind(this),
                    function clickedNay() {
                    }.bind(this));
            } else {
                this.setWorkflowInstance(workflow);
            }
        },

        setWorkflowInstance: function setWorkflowInstance(workflow) {
            this.showSavingIndicator = true;
            if (workflow) {
                this.WorkflowManager.setWorkflowInstanceOnWorkspace(this.workspace._id, workflow._id)
                    .then(function success(resp) {
                        this.WorkflowService.setWorkspaceWorkflowObj(resp.data);
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.workflow_apply_to_workspace);
                        resp.data.workflow_steps.forEach(function (step) {
                            if (step.workflow_step_trigger.trigger_date && this.moment(step.workflow_step_trigger.trigger_date).diff(this.moment(), 'days') < 0) {
                                this.showOverDuoAlert = true;
                                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info,
                                    'WORKFLOW.ALERTS._ADD_WORKFLOW_OVERDUO_STEPS', function success() {
                                        this.showSavingIndicator = false;
                                        this.modalInstance.dismiss();
                                        this.ModalService.openfullviewWorkflowModal(this.workspace, workflow._id);
                                        return;
                                    }.bind(this));
                            }
                        }.bind(this));
                    }.bind(this))
                    .catch(function fail(resp) {
                    }.bind(this))
                    .finally(function finallyHandler() {
                        if (!this.showOverDuoAlert) {
                            this.showSavingIndicator = false;
                            this.modalInstance.dismiss();
                            this.ModalService.openfullviewWorkflowModal(this.workspace, workflow._id);
                        }
                    }.bind(this));
            }
        },
    });
}());
